import { render, staticRenderFns } from "./RestaurantDetail.vue?vue&type=template&id=25febcac&"
import script from "./RestaurantDetail.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports